import ImageLoader, {ImageLoaderProps} from '../image-loader';
import {LeoPromotionBadgeWrapper} from './styles';
import {Collection} from './types';

export type LeoPromotionsBadgeProps = {
  promotionInfo: Collection;
  className?: string;
  removeImageSkeleton?: boolean;
};

export const LeoPromotionsBadge: React.FC<LeoPromotionsBadgeProps> = ({
  promotionInfo,
  className,
  removeImageSkeleton
}) => {
  if (promotionInfo?.imageUrl) {
    const imageProps: ImageLoaderProps = {
      image: {
        src: promotionInfo.imageUrl,
        alt: 'Promotion',
        objectFit: 'contain',
        objectPosition: 'left',
        layout: 'fill'
      },
      skelton: {
        width: 140,
        height: 30,
        variant: 'rounded'
      }
    };
    return (
      <LeoPromotionBadgeWrapper>
        <ImageLoader removeImageSkeleton={removeImageSkeleton} className={className} {...imageProps} />
      </LeoPromotionBadgeWrapper>
    );
  }

  return <></>;
};
